import { BackButton } from "../back-button";

type PageHeaderProps = {
  header: string;
  onBack?: () => void;
};

export const PageHeader = ({ header, onBack }: PageHeaderProps) => {
  return (
    <div className="mb-6 flex flex-col items-start gap-1">
      <h1 className="font-heading font-serif text-2xl lg:text-4xl">{header}</h1>
      {onBack && <BackButton onClick={onBack} className="mt-1" />}
    </div>
  );
};
